import { Component, OnInit, Injector, AfterViewInit, ViewContainerRef, ViewChild, OnDestroy } from '@angular/core';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MainLayoutPageComponent } from 'src/app/shared/component/main-layout-page/main-layout-page.component';
import { RouterComponent } from 'src/app/shared/component/router/router.component';
import { HeaderComponent } from '../header/header.component';
import { SideNavBarComponent } from '../side-nav-bar/side-nav-bar.component';
import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { NavBarService } from 'src/app/shared/services/nav-bar.service';
import { AppBloc, InitApplicationTheme, ThemeReadyState, UpdateThemeReadyState } from 'src/app/shared/bloc/app-bloc';
import { BlocState } from 'src/app/shared/bloc/base-bloc';
import { takeUntil } from 'rxjs';
import { ThemesService } from 'src/app/core/services/themes.service';
import { PushNotificationService } from 'src/app/core/services/push-notification.service';
import { LoadingService } from 'src/app/shared/helper';
import { NotificationsListComponent } from '../notifications-list-component/notifications-list.component';
import { CommonModule } from '@angular/common';
import { NotificationsSidebarService } from 'src/app/core/services/notifications-sidebar-service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { LocalStorageHelper } from 'src/app/shared/helper/local-storage-helper';
import { SharedConstants } from 'src/app/shared/common';

@Component({
  selector: 'app-layout-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    TranslateModule,
    MatDialogModule,
    HeaderComponent,
    RouterComponent,
    MainLayoutPageComponent,
    SideNavBarComponent,
    NotificationsListComponent,
  ],
  templateUrl: './layout-wrapper.component.html',
  styleUrls: ['./layout-wrapper.component.scss'],
})
export class LayoutWrapperComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  isNotificationCenterOpen: boolean;
  isThemeUpdated: boolean = LocalStorageHelper.getItem(SharedConstants.LOCAL_STORAGE_THEME_UPDATE_KEY) === 'true';
  @ViewChild('dynamicComponent', { read: ViewContainerRef }) snackbar: ViewContainerRef;
  @ViewChild('notifications_sidenav', { static: true }) notificationCenter: MatSidenav;

  list = Array.from({ length: 200 }, (_, i) => i + 1);

  //getters
  get isCollapsed(): boolean {
    return this.injector.get(NavBarService).isSideNavCollapsed;
  }

  constructor(
    injector: Injector,
    private appBloc: AppBloc,
    private themeService: ThemesService,
    private pushNotificationService: PushNotificationService,
    private notificationsSidebarService: NotificationsSidebarService
  ) {
    super([], injector);
    this.appBloc.onState.pipe(takeUntil(this.destroy$)).subscribe((state) => this.onHandleAppBlocState(state));
    this.notificationsSidebarService.openNotificationSideBar$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.openNotificationCenter(value));
  }

  ngOnInit(): void {
    this.initiTheme();
  }

  ngAfterViewInit(): void {
    this.pushNotificationService.messagingSetup(this.snackbar);
    this.handleThemeChange();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.injector.get(MatDialog).closeAll();
  }

  protected onCloseNotificationCenter(): void {
    this.isNotificationCenterOpen = false;
  }

  private openNotificationCenter(isOpen: boolean): void {
    if (isOpen) {
      this.isNotificationCenterOpen = true;
      this.notificationCenter?.open();
    }
  }

  private handleThemeChange(): void {
    if (this.isThemeUpdated) {
      this.injector.get(LoadingService).stopLoading();
      LocalStorageHelper.setItem(SharedConstants.LOCAL_STORAGE_THEME_UPDATE_KEY, false);
    }
  }

  private initiTheme(): void {
    if (!this.isThemeUpdated) {
      this.appBloc.setEvent.next(new InitApplicationTheme());
    }
  }

  private onHandleAppBlocState(state: BlocState): void {
    if (state instanceof ThemeReadyState) {
      this.themeService.setTheme(state.theme);
    } else if (state instanceof UpdateThemeReadyState) {
      this.themeService.setTheme(state.theme);
      LocalStorageHelper.setItem(SharedConstants.LOCAL_STORAGE_THEME_UPDATE_KEY, true);
      window.location.reload();
    }
  }
}
